import { Component, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaintenanceService } from './maintenance.service';

@Component({
    selector: 'app-maintenance-modal',
    standalone: true,
    imports: [CommonModule],
    template: `
        <div *ngIf="maintenanceService.isMaintenanceMode$ | async"
             class="fixed inset-0 z-[9999] flex items-center justify-center bg-black/60 backdrop-blur-sm">
            <div class="bg-white rounded-2xl shadow-2xl p-8 max-w-[320px] w-full mx-4 text-center">
                <!-- Animated Icon -->
                <div class="mb-6 flex justify-center">
                    <div class="relative">
                        <!-- Outer rotating ring -->
                        <svg class="w-20 h-20 animate-spin-slow" viewBox="0 0 100 100">
                            <circle cx="50" cy="50" r="45" fill="none" stroke="#E5E7EB" stroke-width="6"/>
                            <circle cx="50" cy="50" r="45" fill="none" stroke="#3B82F6" stroke-width="6"
                                    stroke-dasharray="70 200" stroke-linecap="round"/>
                        </svg>
                        <!-- Center gear icon -->
                        <div class="absolute inset-0 flex items-center justify-center">
                            <svg class="w-10 h-10 text-blue-600 animate-pulse" fill="currentColor" viewBox="0 0 24 24">
                                <path d="M12 15.5A3.5 3.5 0 0 1 8.5 12A3.5 3.5 0 0 1 12 8.5a3.5 3.5 0 0 1 3.5 3.5a3.5 3.5 0 0 1-3.5 3.5m7.43-2.53c.04-.32.07-.64.07-.97c0-.33-.03-.66-.07-1l2.11-1.63c.19-.15.24-.42.12-.64l-2-3.46c-.12-.22-.39-.31-.61-.22l-2.49 1c-.52-.39-1.06-.73-1.69-.98l-.37-2.65A.506.506 0 0 0 14 2h-4c-.25 0-.46.18-.5.42l-.37 2.65c-.63.25-1.17.59-1.69.98l-2.49-1c-.22-.09-.49 0-.61.22l-2 3.46c-.13.22-.07.49.12.64L4.57 11c-.04.34-.07.67-.07 1c0 .33.03.65.07.97l-2.11 1.66c-.19.15-.25.42-.12.64l2 3.46c.12.22.39.3.61.22l2.49-1.01c.52.4 1.06.74 1.69.99l.37 2.65c.04.24.25.42.5.42h4c.25 0 .46-.18.5-.42l.37-2.65c.63-.26 1.17-.59 1.69-.99l2.49 1.01c.22.08.49 0 .61-.22l2-3.46c.12-.22.07-.49-.12-.64l-2.11-1.66Z"/>
                            </svg>
                        </div>
                    </div>
                </div>

                <!-- Title -->
                <h2 class="text-xl font-semibold text-gray-900 mb-2">
                    Sistema em Atualização
                </h2>

                <!-- Message -->
                <p class="text-sm text-gray-600 mb-6">
                    Estamos realizando melhorias no sistema. Tente novamente em alguns minutos.
                </p>

                <!-- Progress dots -->
                <div class="flex justify-center gap-1.5">
                    <div class="w-2 h-2 bg-blue-600 rounded-full animate-bounce" style="animation-delay: 0ms"></div>
                    <div class="w-2 h-2 bg-blue-600 rounded-full animate-bounce" style="animation-delay: 150ms"></div>
                    <div class="w-2 h-2 bg-blue-600 rounded-full animate-bounce" style="animation-delay: 300ms"></div>
                </div>
            </div>
        </div>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MaintenanceModalComponent {
    constructor(public maintenanceService: MaintenanceService) {}
}
